class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
    this.expandSynonymSearchResults();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  async expandSynonymSearchResults() {
    if (!window.location.pathname.endsWith('/search')) return;

    const currentUrl = new URL(window.location.href);
    const query = currentUrl.searchParams.get('q')?.trim();
    if (!query) return;

    const variants = window.PerfumerySearchSynonyms?.getVariants(query) || [query];
    if (variants.length < 2) return;

    const currentGrid = document.querySelector('#product-grid');
    const currentList = currentGrid?.querySelector('ul.product-grid');
    const sectionId = currentGrid?.dataset.id;
    if (!currentGrid || !currentList || !sectionId) return;

    const normalize = window.PerfumerySearchSynonyms?.normalize || ((value) => String(value).toLowerCase());
    const originalKey = normalize(query);
    const termsToFetch = variants.filter((term) => normalize(term) !== originalKey);
    const searchUrl = new URL(this.input.form.action, window.location.origin);

    try {
      const texts = await Promise.all(termsToFetch.map((term) => {
        const url = new URL(searchUrl);
        url.searchParams.set('q', term);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('section_id', sectionId);
        return fetch(url.toString()).then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        });
      }));

      const getProductKey = (item) => {
        const href = item.querySelector('a[href*="/products/"]')?.getAttribute('href');
        if (!href) return null;

        try {
          const url = new URL(href, window.location.origin);
          const match = url.pathname.match(/\/products\/([^/]+)/i);
          if (match?.[1]) return decodeURIComponent(match[1]).toLowerCase();
          return url.pathname.replace(/\/+$/, '').toLowerCase();
        } catch (error) {
          return href.split('?')[0].split('#')[0].replace(/\/+$/, '').toLowerCase();
        }
      };

      const uniqueProducts = new Map();
      const collect = (root) => {
        root.querySelectorAll('ul.product-grid > li.grid__item').forEach((item) => {
          const key = getProductKey(item);
          if (key && !uniqueProducts.has(key)) uniqueProducts.set(key, item);
        });
      };

      collect(document);
      texts.forEach((text) => collect(new DOMParser().parseFromString(text, 'text/html')));
      if (!uniqueProducts.size) return;

      currentList.innerHTML = '';
      uniqueProducts.forEach((item) => currentList.appendChild(item.cloneNode(true)));

      currentGrid.querySelector('.pagination-wrapper')?.remove();
      document.querySelector('#main-search-filters')?.remove();
      document.querySelector('.facets-vertical-sort')?.remove();

      const countDesktop = document.querySelector('#ProductCountDesktop');
      if (countDesktop) countDesktop.textContent = String(uniqueProducts.size);
    } catch (error) {
      console.warn('Synonym search expansion failed; keeping Shopify results.', error);
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) this.keepInSync('', this.input);
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    if (window.innerWidth < 750) this.scrollIntoView({ behavior: 'smooth' });
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) input.value = value;
    });
  }
}

customElements.define('main-search', MainSearch);
